module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var constants = require('Constants.js').default;

    ; __append("\r\n\r\n    <h2 style=\"margin-top: 0;\">Connections Help</h2>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-10\">&nbsp;&nbsp;\r\n            <a href=\"")
    ; __append(escapeFn(constants.HELP_CONNS_INTEGRATION ))
    ; __append("\" target=\"_blank\">Administering Connections and Integration</a>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-10\">&nbsp;&nbsp;\r\n            <a href=\"")
    ; __append(escapeFn(constants.HELP_CONNS ))
    ; __append("\" target=\"_blank\">Creating Connections</a>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-10\">&nbsp;&nbsp;\r\n            <a href=\"")
    ; __append(escapeFn(constants.HELP_CONNS_ACTIONS ))
    ; __append("\" target=\"_blank\">Defining Connection Actions</a>\r\n        </div>\r\n    </div>")
  }
  return __output;

}